import PropTypes from 'prop-types';
import { Spinner } from '@celltrak/ui-components';

import useVisitPayloadTab from './hooks';
import styles from './VisitPayloadTab.module.scss';

const VisitPayloadTab = ({ isLoading }) => {
  const visitPayloadInfo = useVisitPayloadTab();

  const renderSpinner = () => (
    <div className={styles.spinnerContainer}>
      <Spinner>Loading...</Spinner>
    </div>
  );

  const renderVisitPayloadInfo = () => (
    <div>
      <pre>{visitPayloadInfo}</pre>
    </div>
  );

  return (
    <div className={styles.visitPayloadTab}>
      {isLoading ? renderSpinner() : renderVisitPayloadInfo()}
    </div>
  );
};

VisitPayloadTab.propTypes = {
  isLoading: PropTypes.bool,
};

VisitPayloadTab.defaultProps = {
  isLoading: true,
};

export default VisitPayloadTab;
